import React, {createContext,useContext,useEffect,useMemo,useState} from 'react';
import catalog from './catalog.json';

export const LANGUAGES=[{code:'ht',name:'Kreyòl ayisyen'},{code:'es',name:'Español'},{code:'fr',name:'Français'},{code:'en',name:'English'}];
const KEY='mktransfe.language';
const supported=value=>LANGUAGES.some(l=>l.code===value);
const read=()=>{try{const value=localStorage.getItem(KEY);return supported(value)?value:'ht';}catch{return 'ht';}};
let currentLanguage=read();
const Context=createContext({language:'ht',setLanguage:()=>{}});
export function translate(value,language=currentLanguage){
 if(typeof value!=='string'||language==='ht')return value;
 const key=value.replace(/\s+/g,' ').trim();
 const translated=catalog[key]?.[language];
 if(!translated)return value;
 return (value.match(/^\s+/)?.[0]||'')+translated+(value.match(/\s+$/)?.[0]||'');
}
export const useLanguage=()=>useContext(Context);
export function LocalizedText({value}){const {language}=useLanguage();return <>{translate(value,language)}</>;}
export function LanguageProvider({children}){
 const [language,setValue]=useState(read);
 const setLanguage=code=>{if(!supported(code))return;currentLanguage=code;setValue(code);try{localStorage.setItem(KEY,code);}catch{/* Preference still applies for this session. */}};
 useEffect(()=>{currentLanguage=language;document.documentElement.lang=language;},[language]);
 useEffect(()=>{const sync=e=>{if(e.key===KEY){const code=supported(e.newValue)?e.newValue:'ht';currentLanguage=code;setValue(code);}};window.addEventListener('storage',sync);return()=>window.removeEventListener('storage',sync);},[]);
 const context=useMemo(()=>({language,setLanguage}),[language]);
 // A prop update re-renders the application without remounting its routes/forms.
 const rendered=React.Children.map(children,child=>React.isValidElement(child)?React.cloneElement(child,{__mkLanguage:language}):child);
 return <Context.Provider value={context}>{rendered}</Context.Provider>;
}
